module.exports = __webpack_public_path__ + "img/1268.f344b94c.jpg";